import type { PlaceType, RelatedPlace } from "./api";
import type { IconType } from "~/components/ui/icons/icon";

export interface RelatedPlaceCategory {
  label: string;
  emptyLabel: string;
  icon: IconType;
  types: PlaceType[] | null;
}

export const OTHER_SPOTS_LABEL = "Other spots";

export const RELATED_PLACE_CATEGORIES: RelatedPlaceCategory[] = [
  { label: "Parking", emptyLabel: "Where should we leave the car?", icon: "parking", types: ["parking"] },
  { label: "Huts", emptyLabel: "Any mountain huts or shelters on the way?", icon: "cabin", types: ["hut"] },
  { label: "Hot Springs", emptyLabel: "Know a good spot to warm up?", icon: "hot-spring", types: ["hot-spring"] },
  { label: OTHER_SPOTS_LABEL, emptyLabel: "Any other useful spots?", icon: "map-pin", types: null },
];

export function groupRelatedPlaces(
  places: RelatedPlace[],
  categories: RelatedPlaceCategory[],
): Map<string, RelatedPlace[]> {
  const result = new Map<string, RelatedPlace[]>();
  const assigned = new Set<string>();

  for (const category of categories) {
    if (category.types === null) continue;
    const matching = places.filter((p) => category.types!.includes(p.type) && !assigned.has(p.id));
    result.set(category.label, matching);
    matching.forEach((p) => assigned.add(p.id));
  }

  result.set(
    OTHER_SPOTS_LABEL,
    places.filter((p) => !assigned.has(p.id)),
  );
  return result;
}
